import { render, staticRenderFns } from "./prestore.vue?vue&type=template&id=544292da&scoped=true&"
import script from "./prestore.vue?vue&type=script&lang=js&"
export * from "./prestore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544292da",
  null
  
)

export default component.exports